var jade = require("/var/lib/jenkins-code/academia-app/node_modules/.pnpm/jade@1.11.0/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div><a style=\"border-top-right-radius: 0; border-top-left-radius: 0;\" class=\"js-SiteSearch-results-viewAll btn btn-block u-pv3x u-fw700 u-fs13 u-borderTop1 u-borderColorGrayLight\">VIEW ALL RESULTS</a></div>");;return buf.join("");
}